import {
  IconDashboard,
  IconOrders,
  IconClients,
  IconBilling,
  IconAccounts,
  IconWallet,
  IconReport,
  IconHome,
  IconPlus,
} from "../ui/icons";

export const ROUTES = {
  adminDashboard: "/admin",
  adminOrders: "/admin-orders",
  ordersPerClient: "/orders-per-client",
  clients: "/clients",
  billing: "/bills-per-client",
  currentAccounts: "/clients-for-current-account",
  cashMovements: "/cash-movements",
  cashAdd: "/cash-add",
  cashExtraction: "/cash-extraction",
  checkReports: "/check-reports",
  debtAging: "/reporte-deuda",
  operatorProduction: "/reporte-operadores",
  billingReport: "/reporte-facturacion",
  ivaBook: "/reporte-libro-iva",
  arcaStatus: "/estado-servicios-arca",
  operatorHome: "/",
  operatorOrders: "/order-table",
  newOrder: "/new-order",
};

/** Menú lateral del administrador, agrupado por bloque de trabajo. */
export const adminNavSections = [
  {
    label: "Operación",
    items: [
      { id: "panel", label: "Panel", icon: IconDashboard, path: ROUTES.adminDashboard },
      {
        id: "ordenes",
        label: "Órdenes",
        icon: IconOrders,
        children: [
          { label: "Listado de órdenes", path: ROUTES.adminOrders },
          { label: "Órdenes por cliente", path: ROUTES.ordersPerClient },
        ],
      },
      { id: "clientes", label: "Clientes", icon: IconClients, path: ROUTES.clients },
    ],
  },
  {
    label: "Administración",
    items: [
      { id: "facturacion", label: "Facturación", icon: IconBilling, path: ROUTES.billing },
      {
        id: "cuentas",
        label: "Cuentas corrientes",
        icon: IconAccounts,
        path: ROUTES.currentAccounts,
      },
      {
        id: "caja",
        label: "Caja",
        icon: IconWallet,
        children: [
          { label: "Ver movimientos", path: ROUTES.cashMovements },
          { label: "Ingresar dinero", path: ROUTES.cashAdd },
          { label: "Retirar dinero", path: ROUTES.cashExtraction },
        ],
      },
      {
        id: "reportes",
        label: "Reportes",
        icon: IconReport,
        children: [
          { label: "Facturación por período", path: ROUTES.billingReport },
          { label: "Antigüedad de deuda", path: ROUTES.debtAging },
          { label: "Producción por operador", path: ROUTES.operatorProduction },
          { label: "Libro IVA compras y ventas", path: ROUTES.ivaBook },
          { label: "Cheques", path: ROUTES.checkReports },
          { label: "Estado servicios ARCA", path: ROUTES.arcaStatus },
        ],
      },
    ],
  },
];

/** Menú lateral del operador: pocas paradas, todas de trabajo de campo. */
export const operatorNavSections = [
  {
    label: "Trabajo",
    items: [
      { id: "inicio", label: "Inicio", icon: IconHome, path: ROUTES.operatorHome },
      { id: "ordenes", label: "Órdenes", icon: IconOrders, path: ROUTES.operatorOrders },
      { id: "nueva", label: "Nueva orden", icon: IconPlus, path: ROUTES.newOrder },
      { id: "clientes", label: "Clientes", icon: IconClients, path: ROUTES.clients },
    ],
  },
];

/** Barra inferior: 4 destinos + el botón central de nueva orden. */
export const adminBottomNav = [
  { label: "Panel", icon: IconDashboard, path: ROUTES.adminDashboard },
  { label: "Órdenes", icon: IconOrders, path: ROUTES.adminOrders },
  { label: "Clientes", icon: IconClients, path: ROUTES.clients },
];

export const operatorBottomNav = [
  { label: "Inicio", icon: IconHome, path: ROUTES.operatorHome },
  { label: "Órdenes", icon: IconOrders, path: ROUTES.operatorOrders },
  { label: "Clientes", icon: IconClients, path: ROUTES.clients },
];

/** Título que muestra la barra superior según la ruta. */
export const PAGE_TITLES = {
  [ROUTES.adminDashboard]: "Panel",
  [ROUTES.adminOrders]: "Órdenes de servicio",
  [ROUTES.ordersPerClient]: "Órdenes por cliente",
  [ROUTES.clients]: "Clientes",
  [ROUTES.billing]: "Facturación",
  [ROUTES.currentAccounts]: "Cuentas corrientes",
  "/client-current-account": "Cuenta corriente",
  [ROUTES.cashMovements]: "Movimientos de caja",
  [ROUTES.cashAdd]: "Ingresar dinero",
  [ROUTES.cashExtraction]: "Retirar dinero",
  [ROUTES.checkReports]: "Reporte de cheques",
  [ROUTES.billingReport]: "Facturación por período",
  [ROUTES.debtAging]: "Antigüedad de deuda",
  [ROUTES.operatorProduction]: "Producción por operador",
  [ROUTES.ivaBook]: "Libro IVA compras y ventas",
  [ROUTES.arcaStatus]: "Estado servicios ARCA",
  [ROUTES.operatorHome]: "Inicio",
  [ROUTES.operatorOrders]: "Órdenes",
  [ROUTES.newOrder]: "Nueva orden",
  "/edit-order": "Editar orden",
  "/edit-client": "Cliente",
  "/order-details-form": "Detalle de orden",
  "/order-details-view": "Detalle de orden",
  "/client-specific-orders": "Órdenes del cliente",
  "/client-bill-details": "Detalle de factura",
  "/register-bill-payment": "Registrar pago",
  "/ticket-details-form": "Detalle de factura",
};

export const getPageTitle = (pathname) => PAGE_TITLES[pathname] || "Support IT";
